import { Button, Stack, Typography } from '@mui/material'
import { Form, useForm } from 'react-hook-form'
import { FormStyledTextField } from '~/@ui/form/FormStyledTextField'
import { ProgressBar } from '~/@ui/progress-bar/ProgressBar'
import { SimplePageWrapper } from '~/@ui/simple-page-wrapper/SimplePageWrapper'
import { SliderWithButtons } from '~/@ui/slider/SliderWithButtons/SliderWithButtons'
import { ownerScheme, OwnerScheme } from './_scheme/owner.scheme'
import { zodResolver } from '@hookform/resolvers/zod'
import { useAlert } from '~/@ui/alert/useAlert'
import { getFormErrorMessage } from '~/@utils/form/getFormErrorMessage'
import { useNavigate } from 'react-router-dom'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'
import { useCurrentUserData } from '~/@biz_account/useCurrentUserData/useCurrentUserData'
import { useEffect } from 'react'
import { Header } from '~/@ui/header/Header'

const defaultValues = {
  firstName: '',
  lastName: '',
  age: 75,
}

export const OwnerFormPage = () => {
  const navigate = useNavigate()
  const { showAlert } = useAlert()
  const { user } = useCurrentUserData()

  const { control, trigger, getFieldState, watch, getValues, setValue } =
    useForm<OwnerScheme>({
      resolver: zodResolver(ownerScheme),
      mode: 'onBlur',
      defaultValues: defaultValues,
    })

  const age = watch('age')

  const updatePersonalInformation = async () => {
    const firstName = getValues('firstName')
    const lastName = getValues('lastName')
    const age = getValues('age')

    try {
      const { data: response } =
        await getApi().personalInformationsAppApiControllerUpdatePersonalInformation2(
          {
            firstName,
            lastName,
            age,
          }
        )

      if ('success' in response) {
        navigate('/vlastnik/dotaznik/adresa-nehnutelnosti')
        return
      }

      throw new Error('Nasatala neznáma chyba pri odosielaní osobných údajov.')
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  const handleSubmit = async () => {
    const isValid = await trigger()

    if (!isValid) {
      const errorMessage = getFormErrorMessage(defaultValues, getFieldState)
      showAlert('error', errorMessage)
      return
    }

    updatePersonalInformation()
  }

  useEffect(() => {
    setValue('firstName', user?._personalInformation?.firstName || '')
    setValue('lastName', user?._personalInformation?.lastName || '')
    setValue('age', user?._personalInformation?.age || 75)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  return (
    <SimplePageWrapper
      onClickBack={() => navigate('/vlastnik/portfolio')}
      className="pb-28">
      <Stack className="px-5">
        <ProgressBar className="mt-[26px]" manualPercentage={[100, 0, 0, 0]} />
        <Header
          title="Informácie o žiadateľovi"
          text="Prosíme, zadajte svoje osobné údaje."
          className="mt-3"
        />
        <Form control={control} className="flex flex-col gap-3 mt-8">
          <FormStyledTextField
            control={control}
            name="firstName"
            placeholder="Meno"
          />
          <FormStyledTextField
            control={control}
            name="lastName"
            placeholder="Priezvisko"
          />

          <Stack className="gap-5 px-4 pt-4 pb-3 bg-zGrey200 rounded-4d">
            <Typography className="text-base font-semibold text-zBlack200">
              Aktuálny vek
            </Typography>
            <SliderWithButtons
              darkTheme
              className="gap-2"
              name={'age'}
              suffix="rokov"
              control={control}
              min={19}
              max={95}
              step={1}
              hideMinMax
            />
          </Stack>
        </Form>

        <Stack className="gap-3 mt-[72px]">
          <Button
            variant="contained"
            className="w-fit h-14 self-center px-10"
            onClick={handleSubmit}
            disabled={age < 65}>
            Pokračovať
          </Button>
          {age < 65 && (
            <Button
              variant="contained"
              className="w-fit h-14 self-center px-6"
              onClick={() =>
                (window.location.href = 'https://bonaship.sk/investor')
              }>
              Pokračovať ako Investor
            </Button>
          )}
        </Stack>
      </Stack>
    </SimplePageWrapper>
  )
}
